import { createElement } from "react";
import { FaCertificate } from 'react-icons/fa';
import { FaPercent } from 'react-icons/fa';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { FaUsers } from 'react-icons/fa';
import { SiGarmin } from 'react-icons/si';
import { SiGeocaching } from 'react-icons/si';
import { SiOpenstreetmap } from 'react-icons/si';
import { FaLock } from 'react-icons/fa';
import { FaRegKeyboard } from 'react-icons/fa';
export default [
{ key: "attribution", lang: "en", title: "Map License", icon: createElement(FaCertificate), order: 300 },
{ key: "attribution", lang: "sk", title: "Licencia máp" },
{ key: "dvePercenta", lang: "sk", title: "Dve percentá", icon: createElement(FaPercent), order: 1000 },
{ key: "exports", lang: "en", title: "Map Exports", listed: false, icon: createElement(FaExternalLinkAlt) },
{ key: "exports", lang: "it", title: "Mappa per apparati GPS" },
{ key: "exports", lang: "sk", title: "Exporty máp" },
{ key: "freemap", lang: "en", title: "About Freemap Association", icon: createElement(FaUsers), order: 100 },
{ key: "freemap", lang: "sk", title: "O združení Freemap" },
{ key: "garmin", lang: "en", title: "Garmin", icon: createElement(SiGarmin), order: 600 },
{ key: "garmin", lang: "sk", title: "Garmin" },
{ key: "geocaching", lang: "en", title: "Freemap.sk for Geocaching Extension", icon: createElement(SiGeocaching), order: 700 },
{ key: "geocaching", lang: "sk", title: "Rozšírenie Freemap.sk for Geocaching" },
{ key: "osm", lang: "en", title: "About OpenStreetMap", icon: createElement(SiOpenstreetmap), order: 200 },
{ key: "osm", lang: "sk", title: "O OpenStreetMap" },
{ key: "outdoorShadingAttribution", lang: "en", title: "Attribution", listed: false, icon: createElement(FaCertificate) },
{ key: "outdoorShadingAttribution", lang: "sk", title: "Atribúcia" },
{ key: "privacyPolicy", lang: "en", title: "Privacy Policy", listed: false, icon: createElement(FaLock) },
{ key: "privacyPolicy", lang: "sk", title: "Zásady ochrany osobných údajov" },
{ key: "shortcuts", lang: "en", title: "Keyboard Shortcuts", icon: createElement(FaRegKeyboard), order: 400 },
{ key: "shortcuts", lang: "sk", title: "Klávesové skratky" },
];